/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import SweetAlert from 'sweetalert2/src/sweetalert2.js';
import { getUsers, deleteUsers } from '../../../api/api';
import { useStateContext } from '../../../contexts/ContextProvider';
import { Trash2 } from 'react-feather';

function containsError(item) {
  return Object.prototype.hasOwnProperty.call(item, 'Error');
}

function DeleteUser({ usrId }) {
  const { basictoaster, setUsers, setExecuting } = useStateContext();

  const delUserH = () => {
    SweetAlert.fire({
        title: 'Sei sicuro?',
        text: 'Il tuo utente verrà cancellato',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'cancel',
        reverseButtons: true
    })
        .then(async (result) => {
          if (result.value) {
            setExecuting(true);
            deleteUsers(usrId).then(async (response) => {
              if (response.Success) {
                  SweetAlert.fire( 
                    'Fatto!',
                    'Il tuo utente è stato cancellato.',
                    'success'
                  );
              } else if (containsError(response)) {
                SweetAlert.fire(
                  'Errore!',
                  `Errore: ${response.Error}.`,
                  'error'
                );
              }
              getUsers().then((newsResp) => {
                setUsers(newsResp);
              }).catch((err) => {basictoaster("error", "Errore utenti", err, () => {})});
            });
          }
          setExecuting(false);
        }).catch((err) => {basictoaster("error", 'Errore eliminazione utenti', err, () => {})});
  };

  return (
      <button className='imgButton' onClick={delUserH}><Trash2 width={20} /></button>
  );
}

export default DeleteUser;
